import { Routes } from '@angular/router';

import { PlaceholderPage } from './pages/placeholder-page/placeholder-page';
import { canLeaveStorageLocationStructure } from './pages/storage-locations/storage-location-structure/storage-location-structure.guard';
import { canLeaveStorageLocations } from './pages/storage-locations/storage-locations.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: async () => {
      const { AngularButton } = await import('./testing/angular-button/angular-button');

      return AngularButton;
    },
    children: [
      {
        path: '',
        loadComponent: async () => {
          const { HelloWorld } = await import('./testing/hello-world/hello-world');

          return HelloWorld;
        },
        data: { storeRoute: '/store' },
      },
      {
        path: 'store',
        loadComponent: async () => {
          const { Store } = await import('./testing/store/store');

          return Store;
        },
        data: { backRoute: '/' },
      },
      {
        path: 'profile',
        loadComponent: async () => {
          const { Profile } = await import('./testing/profile/profile');

          return Profile;
        },
        data: { storeRoute: '/store' },
      },
    ],
  },

  // Exclusive route: the Angular "development root" rendered alone, full width.
  {
    path: 'ima',
    loadComponent: async () => {
      const { HelloWorld } = await import('./testing/hello-world/hello-world');

      return HelloWorld;
    },
    data: { storeRoute: '/ima/store' },
  },
  {
    path: 'ima/store',
    loadComponent: async () => {
      const { Store } = await import('./testing/store/store');

      return Store;
    },
    data: { backRoute: '/ima' },
  },

  // Main sidebar destinations (see src/app/layout/main-nav and
  // src/app/layout/nav-items.ts, which ModuleHeader reads its title from).
  // Placeholders only — IMA-1408 covers the persistent layout/navigation,
  // not these pages.
  { path: 'dashboard', component: PlaceholderPage },
  { path: 'demands', component: PlaceholderPage },
  { path: 'control-center', component: PlaceholderPage },
  {
    path: 'storage-locations',
    loadComponent: async () => {
      const { StorageLocationsPage } = await import('./pages/storage-locations/storage-locations');

      return StorageLocationsPage;
    },
    canDeactivate: [canLeaveStorageLocations],
  },
  {
    path: 'storage-locations/edit-structure',
    canDeactivate: [canLeaveStorageLocationStructure],
    loadComponent: async () => {
      const { StorageLocationStructurePage } =
        await import('./pages/storage-locations/storage-location-structure/storage-location-structure-page');

      return StorageLocationStructurePage;
    },
  },
  {
    path: 'item-catalog',
    loadComponent: async () => {
      const { ItemCatalogPage } = await import('./pages/item-catalog/item-catalog');

      return ItemCatalogPage;
    },
  },
  { path: 'help', component: PlaceholderPage },
  { path: 'settings', component: PlaceholderPage },
  // Exclusive route: standalone Angular input/output pattern examples,
  // rendered alone (not nested under AngularButton) so none of
  // AngularButton's Shell/MFE communication demo UI renders alongside it.
  {
    path: 'angular-inputs',
    loadComponent: async () => {
      const { AngularInputs } = await import('./testing/angular-inputs/angular-inputs');

      return AngularInputs;
    },
  },
];
